import { modalBackgroundColor, modalCloseIconColor } from 'globals/colors';

export const styles = {
  modalContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: modalBackgroundColor,
    zIndex: '9999999999',
    display: 'block',
  },
  modalContent: {
    top: '50%',
    left: '50%',
    position: 'relative',
    transform: 'translate(-50%, -50%)',
    display: 'block',
    width: '600px',
    height: '400px',
    overflow: 'hidden',
    '@media (max-width: 600px)': {
      width: '320px',
    },
  },
  close: {
    color: modalCloseIconColor,
    fontSize: '28px',
    fontWeight: 'bold',
    position: 'absolute',
    top: '10px',
    right: '20px',
    cursor: 'pointer',
    zIndex: '9999999999',
  },
};
